import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSplit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.4375 16.1C8.4375 16.3209 8.61659 16.5 8.8375 16.5H9.1625C9.38341 16.5 9.5625 16.3209 9.5625 16.1V14.8125H13.5C14.6391 14.8125 15.5625 13.8891 15.5625 12.75V5.25C15.5625 4.11091 14.6391 3.1875 13.5 3.1875H9.5625V1.9C9.5625 1.67909 9.38341 1.5 9.1625 1.5H8.8375C8.61659 1.5 8.4375 1.67909 8.4375 1.9V16.1ZM9.5625 4.3125V13.6875H13.5C14.0178 13.6875 14.4375 13.2678 14.4375 12.75V5.25C14.4375 4.73223 14.0178 4.3125 13.5 4.3125H9.5625Z",
		fill: "#33373D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.4375 5.25C2.4375 4.11091 3.36091 3.1875 4.5 3.1875H7.1C7.32091 3.1875 7.5 3.36659 7.5 3.5875V3.9125C7.5 4.13341 7.32091 4.3125 7.1 4.3125H4.5C3.98223 4.3125 3.5625 4.73223 3.5625 5.25V12.75C3.5625 13.2678 3.98223 13.6875 4.5 13.6875H7.1C7.32091 13.6875 7.5 13.8666 7.5 14.0875V14.4125C7.5 14.6334 7.32091 14.8125 7.1 14.8125H4.5C3.36091 14.8125 2.4375 13.8891 2.4375 12.75V5.25Z",
		fill: "#33373D"
	})]
});
export { SvgIconSplit as ReactComponent };
